import CarousellItem from './CarousellItem'

export default CarousellItem
